<template>
    <div class="container-fluid">
        <nav v-if="$route.path.match(/mypage/)">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">お知らせ</li>
            </ol>
        </nav>
        <div class="container px-0">
            <div class="text-muted small">
                運営からのお知らせ一覧です。<br>
                通常の更新履歴や、軽微・重大・破壊的な仕様変更のお知らせ、メンテナンスなどの通知も含みます。
                最新のお知らせは通知欄に表示されます。
            </div>
            <div class="sticky">
                <page :last_page="notices.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div v-if="notices.total">
                <div class="card my-4" v-for="n in notices.data" :key="n.id">
                    <div class="card-header d-flex justify-content-between">
                        <h5>
                            {{n.subject}}
                        </h5>
                        <div data-toggle="tooltip" :title="$filters.dateFormat(n.created_at)">
                            {{$filters.fromNow(n.created_at)}}に告知
                        </div>
                    </div>
                    <div class="card-body">
                        <editor
                            :id="'notice-view-' + n.id"
                            :minHeight="0"
                            :readOnly="true"
                            :content="$filters.jsonParse(n.topic)"
                            class="article"></editor>
                    </div>
                </div>
            </div>
            <div v-else class="nothing">お知らせはありません</div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<script>
import page from "components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            notices: {},
            page: parseInt(this.$route.query.page) || 1,
            isLoading: false,
        }
    },
    methods: {
        goto(p) {
            this.$router.push({
                query: { page: p, }
            });
        },
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            this.isLoading = true;
            this.page = parseInt(this.$route.query.page) || 1;
            axios.get("/notices/get", {params: {page: this.page}}).then(res => {
                this.notices = res.data;
                this.isLoading = false;
                setTimeout(() => {$('[data-toggle="tooltip"]').tooltip();});
            }).catch(err => { alert.err(err.response) });
        },
        makeHead() {
            this.useHead({
                title: "お知らせ | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
            });
        }
    },
    watch: {
        $route(n, o) {
            this.load();
        }
    },
    mounted() {
        this.load();
        this.makeHead();
    },
}
</script>